import React from 'react';
import { CircularProgress, styled } from '@mui/material';
import { PrimaryButton, SecondaryButton } from 'library';

const Loader = styled(CircularProgress)({
    color: 'white',
});

const LoadingButton = (props) => {
    const { children, loading, asSecondary, ...rest } = props;
    if (!asSecondary) {
        return (
            <PrimaryButton {...rest}>
                {!loading && children}
                {loading && <Loader size={20} {...rest} />}
            </PrimaryButton>
        );
    } else {
        return (
            <SecondaryButton {...rest}>
                {!loading && children}
                {loading && <Loader size={20} {...rest} />}
            </SecondaryButton>
        );
    }
};

export default LoadingButton;
